// CLASS NAMES
export const option_dialog_classes = {
  paper: 'Options-paper-MU',
  table: 'Options-table-MU',
  tr: 'Options-tr-MU',
  sliderLegend: 'Options-sliderLegend-MU',
  sliderWrapper: 'Options-sliderWrapper-MU',
  item: 'MuiGrid-item-MU'
};

export const radio_classes = {
  root: 'MuiIconButton-root-MU MuiRadio-root-MU',
  checked: 'MuiPrivateSwitchBase-checked-MU'
};

export const switch_classes = {
  root: 'MuiIconButton-root-MU',
  switchBase: 'MuiSwitch-switchBase-MU',
  icon: 'MuiSwitch-icon-MU',
  bar: 'MuiSwitch-bar-MU'
};
export const slider_classes = {
  track: 'MuiSlider-track-MU',
  thumb: 'MuiSlider-thumb-MU',
  container: 'MuiSlider-container-MU',
  trackAfter: 'MuiSlider-trackAfter-MU',
  disabled: 'MuiSlider-disabled-MU'
};

export const grid_classes = {
  container: 'MuiGrid-container-MU',
  item: 'MuiGrid-item-MU'
};
